var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsFunnelTrafficOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    x: -0.059,
    y: -0.059,
    fill: "#F96A06",
    rx: 32
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 1.5c.966 0 1.841.392 2.475 1.025C8.108 3.16 8.5 4.034 8.5 5c0 .966-.392 1.841-1.025 2.475C6.84 8.108 5.966 8.5 5 8.5c-.966 0-1.841-.392-2.475-1.025C1.892 6.84 1.5 5.966 1.5 5c0-.966.392-1.841 1.025-2.475C3.16 1.892 4.034 1.5 5 1.5zm12 0c.966 0 1.841.392 2.475 1.025C20.108 3.16 20.5 4.034 20.5 5c0 .966-.392 1.841-1.025 2.475C18.84 8.108 17.966 8.5 17 8.5c-.966 0-1.841-.392-2.475-1.025C13.892 6.84 13.5 5.966 13.5 5c0-.966.392-1.841 1.025-2.475C15.16 1.892 16.034 1.5 17 1.5h0zm12 0c.966 0 1.841.392 2.475 1.025C32.108 3.16 32.5 4.034 32.5 5c0 .966-.392 1.841-1.025 2.475C30.84 8.108 29.966 8.5 29 8.5c-.966 0-1.841-.392-2.475-1.025C25.892 6.84 25.5 5.966 25.5 5c0-.966.392-1.841 1.025-2.475C27.16 1.892 28.034 1.5 29 1.5z",
    transform: "translate(15 27)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsFunnelTrafficOther);
export default __webpack_public_path__ + "static/media/illustrations-funnel-traffic-other.04f790ed.svg";
export { ForwardRef as ReactComponent };